import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ADD_UNIVERSITY, GET_STUDENT_TALK_CAT, fetchData } from "../../components/Service";
import { toast } from "react-toastify";
import { Context } from "../../components/Context";
import Select from "react-select";

const AddUniversity = () => {
	const [context] = useContext(Context);
	const [cat, setCat] = useState([]);
	const [selectedCat, setSelectedCat] = useState(null);

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		reset,
		trigger,
	} = useForm({ mode: "onChange" });

	const getCategory = () => {
		fetchData(GET_STUDENT_TALK_CAT, "GET", "", false, false, (res) => {
			if (res.status) {
				setCat(res?.data);
			} else {
				setCat([]);
			}
		});
	};

	const registerUser = (data) => {
		data = {
			user_id: context?.user?.user_id,
			country_id: context?.countryId,
			state_id: context?.stateId,
			...data,
		};

		fetchData(ADD_UNIVERSITY, "POST", data, true, false, (res) => {
			if (res.status) {
				toast.success("University added successfully.");
				reset();

				window.$("#addUniversityModal").modal("hide");
			} else {
				toast.error("Unable to add university.");
			}
		});
	};

	useEffect(() => {
		getCategory();
	}, []);

	return (
		<div
			className="modal fade pe-0"
			id="addUniversityModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content">
					<button
						className="btn-close"
						type="button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={() => {
							reset();
							setSelectedCat(null);
							setValue("category_id", "");
						}}
					></button>
					<div className="modal-header d-block text-center border-bottom-0">
						<h5 className="text-brand-1 text-capitalize">Add University</h5>
					</div>
					<div className="modal-body px-4 px-xl-5 py-3">
						<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(registerUser)}>
							<div className="row">
								<div className="col-12 mb-2">
									<label>
										Name 
										<span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.name && "is-invalid"}`}
										placeholder="Name"
										maxLength={50}
										{...register("name", {
											required: { value: true, message: "Name is required." },
											pattern: {
												value: /^[A-Za-z ]+$/,
												message: "Only alphabetic characters are allowed.",
											},
										})}
									/>
									{errors.name && <div class="invalid-feedback">{errors.name.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Category <span className="text-danger">*</span>
									</label>
									<Select
										{...register("category_id", {
											required: { value: true, message: "Select a category." },
										})}
										value={selectedCat}
										options={cat?.map((item) => ({
											label: item.name,
											value: item.id,
										}))}
										onChange={(selected) => {
											setSelectedCat(selected);
											setValue("category_id", selected ? selected.value : "");
											trigger("category_id");
										}}
										placeholder="Select a category"
										className={`selectpicker p-0 ${errors.category_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
									/>
									{errors.category_id && <div class="invalid-feedback d-block">{errors.category_id.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>Website</label>
									<input
										className={`form-control bg-transparent ${errors.website && "is-invalid"}`}
										placeholder="Website"
										{...register("website", {
											pattern: {
												value: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
												message: "Website is invalid.",
											},
										})}
									/>
									{errors.website && <div class="invalid-feedback">{errors.website.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Complete Education Field 
										<span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.education_field && "is-invalid"}`}
										placeholder="Complete Education Field"
										maxLength={100}
										{...register("education_field", {
											required: { value: true, message: "Complete Education Field is required." },
											pattern: {
												value: /^[A-Za-z, ]+$/,
												message: "Only alphabetic characters, commas, and spaces are allowed.",
											  },
										})}
									/>
									{errors.education_field && <div class="invalid-feedback">{errors.education_field.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Message
										 <span className="text-danger">*</span>
									</label>
									<textarea
										class={`form-control ${errors.message && "is-invalid"}`}
										rows="5"
										placeholder="Message"
										{...register("message", {
											required: { value: true, message: "Message is required." },
										})}
									></textarea>
									{errors.message && <div class="invalid-feedback d-block">{errors.message.message}</div>}
								</div>
							</div>
							<div className="modal-footer d-block text-center border-0">
								<button className={`btn btn-default hover-up m-auto`} type="submit" name="Submit">
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUniversity;
